import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';

export const ImprimirRelacionObrasProyectos = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [report, setReport] = useState('');
    const [valort, setValort] = useState('');
    const [parametro, setParametro] = useState('');
    const [tipo, setTipo] = useState(0);
    const [select, setSelect] = useState(0);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtFecha = useRef();
    const txtChk1 = useRef();
    const txtChk2 = useRef();
    const txtChk3 = useRef();
    const txtChk4 = useRef();
    const txtSelect = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtChk2.current.checked === true) {
            if (txtSelect.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Tipo de Ingreso!', icono: 'informacion' });
                sigue = false;
                txtSelect.current.focus();
            } else {
                imprimirGeneral(parametro, tipo)
            }
        }

        else if (sigue) {
            imprimirGeneral(parametro, tipo)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'tipo') {

            let val;
            if (e.target.value === '1') {
                val = "INGRESO ORDINARIO";
            } else if (e.target.value === '2') {
                val = "PROYECTOS FIDES";
            } else if (e.target.value === '3') {
                val = "PROYECTOS LAEE";
            } else if (e.target.value === '4') {
                val = "FONDO COMPENSACIÓN INTERTERRITORIAL";
            }
            setValort("LISTADO DE " + val);
            if (e.target.value === '4') {
                console.log('pase por aqui')
                console.log(e.target.value)
                setTipo(5);
                setActivo(false);
            } else {
                console.log('pase por aqui dos')
                console.log(e.target.value)
                setTipo(parseInt(e.target.value));
                setActivo(false);
            }

        }
    };

    const onCheck = () => {

        if (txtChk1.current.checked) {
            setSelect(0);
            setParametro("");
            setTipo(0)
            setActivo(false);
        } else if (txtChk2.current.checked) {
            setSelect(1);
            setParametro(" AND CTA.TipoCuenta = ");
        }

    }

    const imprimirGeneral = (val, tip) => {

        var reporte = "";
        if (props.condicion === 'Relacion de Obras') {
            reporte = 'Ing_RelacionObras';
        } else if (props.condicion === 'Resumen General de Obras') {
            reporte = 'Ing_ResumenObras';
        } else if (props.condicion === 'Resumen General de Proyectos') {
            reporte = 'Pres_ResumenProyectos';
        }

        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + val + "&sql3=" + tip, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivo(true);
        setSelect(0);
        setTipo(0);
        setParametro("");
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                /* txtFecha.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                setFecha(fech); */
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir' + ' ' + props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 col-md-11 mx-auto mb-2'>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Todos
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Tipo de Ingreso
                                        </label>
                                    </div>
                                </div>

                                {select === 1 ? <div className='mb-1 col-sm-12'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Tipo de Ingreso:</label>
                                        <select className="form-select text-center" onChange={onChange} ref={txtSelect} aria-label="Default select example " id="tipo" >
                                            <option value="">--Seleccione--</option>
                                            <option value="1">INGRESO ORDINARIO</option>
                                            <option value="2">PROYECTOS FIDES</option>
                                            <option value="3">PROYECTOS LAEE</option>
                                            <option value="4">FONDO COMPENSACIÓN INTERTERRITORIAL</option>
                                        </select>
                                    </div>
                                </div> : ''}

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}